module.exports = __webpack_public_path__ + "img/plan-nan.433d6780.png";